import { render, staticRenderFns } from "./PermissionsCheckboxUsers.vue?vue&type=template&id=1f473723&scoped=true&"
import script from "./PermissionsCheckboxUsers.vue?vue&type=script&lang=js&"
export * from "./PermissionsCheckboxUsers.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsCheckboxUsers.vue?vue&type=style&index=0&id=1f473723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f473723",
  null
  
)

export default component.exports